import React, { useEffect } from "react";
import { Switch, Redirect, useRouteMatch, Route } from "react-router-dom";
import EExchangeVoucherCon from "../comps/Accounts/BackEnd/receipt-voucher/external-exchange-voucher/EEVCon";
import EReceiptVoucherCon from "../comps/Accounts/BackEnd/receipt-voucher/external-receipt-voucher/ERVCon";

import RevAccounting from "../Reviews/Accounts/Balance/RevAccounting";
import RevSandC from "../Reviews/Accounts/Kharji/Casher/RevSandC";
import VoucherTemplate from "../Reviews/Accounts/voucher-template/voucher-template";
import BillTemplate from "../Reviews/Invs/bill-template/bill-template";
import ResturantCasher from "../Reviews/Invs/casher-resturant/RevCasher";
import GoldTemplate from "../Reviews/Invs/gold-template/gold-template";
import ReviewEveryDay from "../Reviews/Sales/EvryDay/ReviewEveryDay";
import Bigen from "../Start/Bigen";
import { RouteWithLayout } from "./components";
import { Main as MainLayout } from "./layouts";

import { NotFound as NotFoundView } from "./views";
import { SubPrintCasher } from "../comps/Settings/PrintCasher";
import { sto } from "../Context/InshData";
import IReceiptVoucherCon from "../comps/Accounts/BackEnd/receipt-voucher/internal-receipt-voucher/IRVCon";
import IExchangeVoucherCon from "../comps/Accounts/BackEnd/receipt-voucher/internal-exchange-voucher/IEVCon";
import InvoicesContianers from "../comps/Invs/BackEnd/Invoices/InvoicesContianers";
import AddItemsContainer from "../comps/bascDatas/Tab1/items/AddItems/ItemsCon";
import DailyReportsCon from "../comps/Sales/BackEnd/Tab1Rout/EveryDay/DailyReortsCon";
import RevMaintainceInv from "../Reviews/Invs/maintaince/maintainceinv";
import ShiftsReportCon from "../comps/Sales/BackEnd/Tab1Rout/ShiftsEmpReport/ShiftsReportCon";
import DefaultInv from "../Reviews/Invs/AFReadyDisigen/DefaultInv";
import SadadInvoicesCon from "../comps/Sales/BackEnd/Tab1Rout/SadadInvoices/SadadInvoicesCon";
import ReviewAmeelMoard from "../Reviews/Customers/Balance/ReviewAmeelMoard";
import ReviewEqfalEveryDay from "../Reviews/Sales/Eqfal/ReviewEqfalEveryDay";
import RevActivityReport from "../Reviews/Sales/Activity/RevActivityReport";
// import RevDailyReport from "../Reviews/Sales/EvryDay/RevDailyReport";
import ReviewJardReport from "../Reviews/Safes/Jard/RevJard";
import RevCostCenter from "../Reviews/Accounts/CostReportPrint/RevCostCenter";
import AccountCustRPTCon from "../comps/Customers/accountCustRPT/accountingRPTCon";
import { inshs } from "../Context/Local";
import SafeGrdCon from "../comps/Safes/BackEnd/safe-grd/SafeGrdCon";
import InvTempalte from "../Reviews/Invs/Inv_Tempalte/Inv_Tempalte";
import RevInvCompany from "../Reviews/Invs/invCompany/RevInvCompany";
import TwreedSafesCon from "../comps/Safes/BackEnd/SarfTwreed/TwreedSafesCon";
import SarfSafesCon from "../comps/Safes/BackEnd/SarfTwreed/SarfSafesCon";
import SafesTaswyaCon from "../comps/Safes/BackEnd/SafesTaswya/SafesTaswyaCon";
import SafesRecieveCon from "../comps/Safes/BackEnd/SafesTransfers.js/SafesRecieveCon";
import ItemsMoveCon from "../comps/Safes/BackEnd/ItemsMovment/ItemsMoveCon";

const Routes = () => {

  if (!sto)
    return (
      <Switch>
        <Route exact path="/" component={Bigen} />
      </Switch>
    );

  return (
    <Switch>
      <Route exact path="/" component={Bigen} />
      <Route
        component={InvoicesContianers}
        exact
        path="/invoices"
        isAllow={true}
      />
      <RouteWithLayout
        component={AddItemsContainer}
        exact
        layout={MainLayout}
        path="/products"
        isAllow={true}
      />

      {/* <Route path="/item" component={AddItemsContainer} /> */}

      <RouteWithLayout
        exact
        layout={MainLayout}
        path="/ReporteveryDay"
        component={DailyReportsCon}
        isAllow={sto.used_Dialy_screen}
      />
      <RouteWithLayout
        exact
        layout={MainLayout}
        path="/Shifts"
        component={ShiftsReportCon}
        isAllow={sto.used_shifts_transClose ?? sto.used_Dialy_screen}
      />

      <RouteWithLayout
        exact
        layout={MainLayout}
        path="/store-supp"
        component={TwreedSafesCon}
        isAllow={sto?.used_twreed_makhzni_screen ?? false}
      />

      <RouteWithLayout
        exact
        layout={MainLayout}
        path="/store-exch"
        component={SarfSafesCon}
        isAllow={sto?.used_sarfe_mkhzni_screen ?? false}
      />
      <RouteWithLayout
        exact
        layout={MainLayout}
        path="/reStore"
        component={SafesTaswyaCon}
        isAllow={sto?.used_tasweay_mkhzni_screen ?? false}
      />

      <RouteWithLayout
        exact
        layout={MainLayout}
        path="/ReceiveST"
        component={SafesRecieveCon}
        isAllow={sto?.used_estlam_mkhzni_screen ?? false}
      />

      <Route path="/ReviewEDay" component={ReviewEveryDay} />

      <RouteWithLayout
        component={SafeGrdCon}
        exact
        layout={MainLayout}
        path="/ReportSafesJard"
        isAllow={sto.used_Jarde_screen}
      />
      <RouteWithLayout
        component={AccountCustRPTCon}
        exact
        layout={MainLayout}
        path="/HesabCustA"
        isAllow={sto.used_Accnt_screen}
      // insh={inshs.Customers[2]}

      />
      <Route path="/ReviewAccount" component={RevAccounting} />

      <RouteWithLayout
        component={EReceiptVoucherCon}
        exact
        layout={MainLayout}
        path="/ext-receipt"
        isAllow={sto.used_Sqabd_screen}
      />
      <RouteWithLayout
        component={EExchangeVoucherCon}
        exact
        layout={MainLayout}
        path="/ext-exchange"
        isAllow={sto.used_SSarf_screen}
      />
      <RouteWithLayout
        component={IReceiptVoucherCon}
        exact
        layout={MainLayout}
        path="/int-receipt"
        isAllow={sto.used_Sqabd_screen}
      />
      <RouteWithLayout
        component={IExchangeVoucherCon}
        exact
        layout={MainLayout}
        path="/int-exchange"
        isAllow={sto.used_SSarf_screen}
      />
      <Route path="/voucher2" component={VoucherTemplate} />
      <Route path="/SC" component={RevSandC} />

      <RouteWithLayout
        component={SubPrintCasher}
        exact
        layout={MainLayout}
        path="/settings"
        isAllow={true}
      />

      <RouteWithLayout
        component={NotFoundView}
        exact
        layout={MainLayout}
        path="/not-found"
        isAllow={true}
      />
      <Route path="/A" component={DefaultInv} />
      <Route path="/bill2" component={BillTemplate} />
      {/* <Route path="/bill4" component={BillTemplateTwo} /> */}
      <Route path="/bill4" component={InvTempalte} />
      <Route path="/gold-bill" component={GoldTemplate} />
      <Route path="/RestCasher" component={ResturantCasher} />
      <Route path="/RevCompany" component={RevInvCompany} />
      <Route path="/RevInv" component={RevMaintainceInv} />
      <Route path="/SadadInvoices" component={SadadInvoicesCon} />
      <Route path="/HesabCustA" component={AccountCustRPTCon} />
      <Route path="/ReviewAaM" component={ReviewAmeelMoard} />
      <Route path="/ReviewEqfal" component={ReviewEqfalEveryDay} />
      <Route path="/ReviewActivity" component={RevActivityReport} />
      {/* <Route path="/RevDailyReport" component={RevDailyReport} /> */}

      <Route path="/ReviewJard" component={ReviewJardReport} />
      <Route path="/ReviewCostCenter" component={RevCostCenter} />
      <Route path="/ReportSafesJard" component={SafeGrdCon} />
      <Route path="/Invoices" component={InvoicesContianers} />
      <Route path="/Invoces" component={InvoicesContianers} />
      <Route path="/curr-details-rpt" component={ItemsMoveCon} />

      <Redirect to="/not-found" />
    </Switch>
  );
};

export default Routes;
